import { INDUSTRY_INSIGHTS } from '@buildwise/libs/insights';

export const CONFIGS = {
  USER_FILTERS: {
    configName: 'USER_FILTERS',
  },
  USER_INPUT_FIELDS: {
    configName: 'USER_INPUT_FIELDS',
  },
  PROJECT_INPUT_FIELDS: {
    configName: 'PROJECT_INPUT_FIELDS',
  },
  PROJECT_FILTERS: {
    configName: 'PROJECT_FILTERS',
  },
  PARTNER_FILTERS: {
    configName: 'PARTNER_FILTERS',
  },
  BUILDWISE_MODULES: {
    configName: 'BUILDWISE_MODULES',
  },
  ARTICLE_FIELDS: {
    configName: 'ARTICLE_FIELDS',
  },
  QUESTION_INPUT_FIELDS: {
    configName: 'QUESTION_INPUT_FIELDS',
  },
  SUGGESTION_INPUT_FIELDS: {
    configName: 'SUGGESTION_INPUT_FIELDS',
  },
  HASHTAGS: {
    configName: 'HASHTAGS',
  },
  JOB_TITLES: {
    configName: 'JOB_TITLES',
  },
  SUGGESTION_STATUSES: {
    configName: 'SUGGESTION_STATUSES',
  },
  COMPANY_FILTERS: {
    configName: 'COMPANY_FILTERS',
  },
  LEARNINGS_SUMMARY_FILTERS: {
    configName: 'LEARNINGS_SUMMARY_FILTERS',
  },
  RETROSPECTIVE_PHASES: {
    configName: 'RETROSPECTIVE_PHASES',
  },
  RETROSPECTIVE_INPUT_FIELDS: {
    configName: 'RETROSPECTIVE_INPUT_FIELDS',
  },
  HELP_CENTER_INPUT_FIELDS: {
    configName: 'HELP_CENTER_INPUT_FIELDS',
  },
  LESSONS_LEARNED_CARD: {
    configName: 'LESSONS_LEARNED_CARD',
  },
  ACTIVITY_LOG_INPUT_FIELDS: {
    configName: 'ACTIVITY_LOG_INPUT_FIELDS',
  },
};

export const INSIGHTS_DATE_OPTIONS = [
  { label: 'This Week', value: '1W' },
  { label: 'One Month', value: '1M' },
  { label: 'Six Months', value: '6M' },
  { label: 'One Year', value: '1Y' },
  { label: 'All', value: 'All' },
];

export const INSIGHTS_TYPE_OPTIONS = [{ label: INDUSTRY_INSIGHTS, value: INDUSTRY_INSIGHTS }];
